import { Component, Input} from '@angular/core';

@Component({
  selector: 'rmt-dropdown-content',
  templateUrl: 'rmt-dropdown-content.html'
})
export class RmtDropdownItemComponent {
  @Input() title: string;
  @Input() titleClass: string;
  contentShow: boolean = false;

  constructor() {
  }

  toggleContentShow(event) {
    this.contentShow = !this.contentShow
  }
}




// WEBPACK FOOTER //
// ./src/components/rmt-dropdown-content/rmt-dropdown-content.ts